var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26651_38551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 0.5H0V14.5H47V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26651_38551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5962 0.5C27.2896 0.5 24.2407 2.1411 24.2407 5.09913C24.2407 8.50289 29.5656 8.74602 29.5656 10.3871C29.5656 11.0962 28.6852 11.8054 27.1608 11.8054C24.9922 11.8054 23.3604 10.8734 23.3604 10.8734L22.7163 13.8111C22.7163 13.8111 24.6272 14.5203 27.032 14.5203C30.725 14.5203 33.5162 12.8792 33.5162 9.81983C33.5162 6.17294 28.1914 6.05137 28.1914 4.41027C28.1914 3.82272 28.9429 3.23517 30.4673 3.23517C32.1206 3.23517 33.5162 3.94428 33.5162 3.94428L34.2892 1.12808C34.2892 1.08755 32.7647 0.5 30.5962 0.5ZM0.128837 0.722865L0 1.18886C0 1.18886 1.39563 1.43198 2.66241 1.89797C4.31568 2.48553 4.4445 2.72865 4.70215 3.7822L7.62221 14.3784H11.6802L17.9068 0.722865H13.9776L9.9196 10.0224L8.26634 2.1411C8.13752 1.20912 7.38603 0.722865 6.48425 0.722865H0.128837ZM19.4312 0.722865L16.2535 14.3784H20.0539L23.2316 0.722865H19.4312ZM40.6446 0.722865C39.7643 0.722865 39.249 1.18886 38.8625 2.01954L33.28 14.5H37.2092L38.0895 12.2713H42.9205L43.4358 14.3987H47L43.9511 0.743126H40.6446V0.722865ZM41.2672 4.36975L42.4052 9.55644H39.2275L41.2672 4.36975Z",
    fill: "#374FA1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.b5a3665c347fb12a858fb87be5c0eb7b.svg";
export { ForwardRef as ReactComponent };